import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-warning hidden-print"
}
const _hoisted_2 = { class: "me-2" }
const _hoisted_3 = { class: "me-3" }
const _hoisted_4 = {
  key: 0,
  class: "me-3"
}
const _hoisted_5 = {
  key: 1,
  class: "me-3"
}
const _hoisted_6 = {
  key: 2,
  class: "me-3"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-3"
}

import { computed, onMounted, ref } from "vue";
import { fetchConflicts } from "../api";
import ConflictTable from "./ConflictTable.vue";
import {
	conflictBadgeClass,
	conflictDetailKey,
	conflictLevelLabel,
	conflictPartnerLabel,
	conflictSubjectLabel,
} from "../../../conflictFormat";


export default {
  __name: 'CourseAppointmentConflicts',
  props: {
	apiUrl: { type: String, required: true },
},
  setup(__props) {

const props = __props;

const loaded = ref(false);
const expanded = ref(false);
const items = ref([]);
const summary = ref({ room: 0, lecturer: 0, cohort: 0, total: 0 });

// One row per distinct conflict (same level + same partner), collapsing recurring conflicts into a
// single row that lists all affected dates – consistent with the pre-save confirmation modal.
const rows = computed(() => {
	const groups = new Map();
	for (const item of items.value) {
		const date = item.appointment.date;
		for (const conflict of item.conflicts || []) {
			const key = conflictDetailKey(conflict);
			if (!groups.has(key)) {
				groups.set(key, {
					level: conflict.level,
					subject: conflictSubjectLabel(conflict),
					partner: conflictPartnerLabel(conflict.with),
					dates: new Set(),
				});
			}
			if (date) {
				groups.get(key).dates.add(date);
			}
		}
	}
	return [...groups.values()].map((group) => ({
		level: group.level,
		when: [...group.dates].join(", "),
		subject: group.subject,
		partner: group.partner,
	}));
});

function decorateRows() {
	document.querySelectorAll(".ca-conflict-flag").forEach((el) => el.remove());

	for (const item of items.value) {
		const id = item.appointment.appointmentId;
		if (!id) continue;

		// One flag per distinct conflict level, each in that level's colour, so multiple
		// conflict types on the same occurrence yield multiple coloured triangles.
		const levels = [...new Set((item.conflicts || []).map((c) => c.level))];
		if (levels.length === 0) continue;

		document.querySelectorAll(`tr[data-appointment-id="${id}"]`).forEach((row) => {
			const cell = row.querySelector("td");
			if (!cell) return;

			for (const level of levels) {
				const badge = document.createElement("span");
				badge.className = `badge ${conflictBadgeClass(level)} ms-1 ca-conflict-flag`;
				badge.title = "Konflikt: " + conflictLevelLabel(level);
				badge.textContent = "⚠";
				cell.appendChild(badge);
			}
		});
	}
}

onMounted(async () => {
	try {
		const data = await fetchConflicts(props.apiUrl);
		items.value = data.items || [];
		summary.value = data.summary || summary.value;
		decorateRows();
	} catch (error) {
		console.error("Konfliktprüfung fehlgeschlagen", error);
	} finally {
		loaded.value = true;
	}
});

return (_ctx, _cache) => {
  return (loaded.value && summary.value.total > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "d-flex align-items-center",
          role: "button",
          onClick: _cache[0] || (_cache[0] = $event => (expanded.value = !expanded.value))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(expanded.value ? "▾" : "▸"), 1 /* TEXT */),
          _createElementVNode("strong", _hoisted_3, " ⚠ " + _toDisplayString(summary.value.total) + " " + _toDisplayString(summary.value.total === 1 ? "Konflikt" : "Konflikte") + " gefunden ", 1 /* TEXT */),
          (summary.value.room)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, "🔴 " + _toDisplayString(summary.value.room) + " Raum", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (summary.value.lecturer)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "🟠 " + _toDisplayString(summary.value.lecturer) + " Dozent*in", 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          (summary.value.cohort)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "🟣 " + _toDisplayString(summary.value.cohort) + " Kohorte", 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ]),
        (expanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(ConflictTable, {
                rows: rows.value,
                "when-label": "Termin(e)"
              }, null, 8 /* PROPS */, ["rows"])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}
}

}